/** Whether the client will consider a settlement on this demand. */

export const SETTLEMENT_CHOICE_HINT =
  'No means the attorney may not agree to a smaller amount that finishes the debt. Yes means they may discuss an offer in Messages. You still confirm the offer before anything is forgiven.';

export const SETTLEMENT_CHOICES = Object.freeze([
  { value: 'NO', label: 'No' },
  { value: 'YES', label: 'Yes' },
]);

/** Missing and unknown values stay No. Yes is not permission to forgive a balance. */
export function normalizeSettlementChoice(value) {
  return String(value || '').trim().toUpperCase() === 'YES' ? 'YES' : 'NO';
}

export function settlementChoiceFromMatter(matter) {
  return normalizeSettlementChoice(
    matter?.Settlement_Choice ?? matter?.settlementChoice
  );
}

export function settlementChoiceLabel(value) {
  return normalizeSettlementChoice(value) === 'YES' ? 'Yes' : 'No';
}

export function settlementChoiceHistoryLabel(value) {
  return normalizeSettlementChoice(value) === 'YES'
    ? 'Will consider a settlement'
    : 'Will not consider a settlement';
}
